export default "__VITE_ASSET__CKO8OKNU__"